import { createTheme } from '@mantine/core'

export const theme = createTheme({
  primaryColor: 'teal',
  defaultRadius: 'md',
  fontFamily: '"Avenir Next", "Segoe UI", sans-serif',
  headings: {
    fontFamily: '"Iowan Old Style", "Palatino Linotype", Georgia, serif',
  },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    Card: {
      defaultProps: {
        radius: 'lg',
        shadow: 'xs',
        withBorder: true,
      },
    },
    Paper: {
      defaultProps: {
        radius: 'lg',
        shadow: 'xs',
        withBorder: true,
      },
    },
  },
})
